import React, { Suspense, useEffect, useRef } from 'react';
import { Routes, Route, BrowserRouter, Navigate, useLocation } from 'react-router-dom';
import { useRootStore } from '@src/model';
// import { isWeiXin } from '@utils/tools';
// import { Loading } from '@ss/mtd-react-mobile';
import Auth from '@elements/Auth';
import WaitJsLoading from '@elements/WaitJsLoading';
// import HeaderAndFooter from '@src/layout/headerAndFooter';
import { getWxConfig } from '@utils/wxConfig';
import { addRaptorCustomError } from '@utils/owlLog';
import NotFound from '../nodes/notFound';
import {
  Home,
  Social,
  Campus,
  // CampusBole,
  Position,
  Question,
  // CampusTv,
  PositionDetail,
  AccountSetting,
  About,
  DeliveryConfirm,
  Login,
  ResumeConfirm,
  Beidou,
  SharePosition,
  // QiHang,
  Trainee,
  PreViewResume,
  DeliverySuccess,
  CampusSchedule,
  Test,
  BeiDouProgram,
  AICoding,
} from './list';

// 路由配置数组
const routes = [
  { path: '/home', element: <Home /> },
  { path: '/test', element: <Test /> },
  { path: '/social', element: <Social /> },
  { path: '/campus', element: <Campus /> },
  { path: '/position', element: <Position /> },
  { path: '/position/detail', element: <PositionDetail /> },
  { path: '/question/:id', element: <Question /> },
  // { path: '/campus/tv', element: <CampusTv /> },
  { path: '/campus/schedule', element: <CampusSchedule /> },
  { path: '/personal-center/:id', element: <AccountSetting />, isAuth: true },
  { path: '/about/:tabType', element: <About /> },
  { path: '/delivery-confirm', element: <DeliveryConfirm />, isAuth: true },
  { path: '/beidou', element: <Beidou /> },
  { path: '/beidouprogram', element: <BeiDouProgram /> },
  // { path: '/qihang', element: <QiHang /> },
  { path: '/trainee', element: <Trainee /> },
  { path: '/share-position', element: <SharePosition /> },
  { path: '/login', element: <Login /> },
  { path: '/resumeConfirm', element: <ResumeConfirm /> },
  { path: '/personalCenter/resumeDetail/preViewResume', element: <PreViewResume /> },
  { path: '/delivery-success', element: <DeliverySuccess />, isAuth: true },
  { path: '/aiCoding', element: <AICoding />, isAuth: true },
];

const RedirectWithSearch = ({ to }: { to: string }) => {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
};

export default function App() {
  const { loginStore, cmsData } = useRootStore();
  const timer = useRef<NodeJS.Timeout>(null);

  const evtListener = (e) => {
    cmsData.setCmsData(e.value?.data);

    // 异常打点
    if (e.value?.error) {
      addRaptorCustomError(
        '[自定义日志打点上报-cms接口异常]',
        'cms接口异常',
        {
          error: JSON.stringify(e.value?.error),
        },
        'error',
      );
    }

    clearTimeout(timer.current || undefined);
  };

  const handleGetCmsData = () => {
    // 兜底策略，3s没有请求数据自动用本地
    // @ts-ignore
    timer.current = setTimeout(() => {
      cmsData.setCmsData(null);
      // 超时打点
      addRaptorCustomError('[自定义日志打点上报-cms接口超时]', 'cms接口超时', {}, 'error');
    }, 3000);

    if (window.cmsData?.data || window.cmsData?.data === null) {
      cmsData.setCmsData(window.cmsData.data);
      // 异常打点
      if (window.cmsData.error) {
        addRaptorCustomError(
          '[自定义日志打点上报-cms接口异常]',
          'cms接口异常',
          {
            error: JSON.stringify(window.cmsData.error),
          },
          'error',
        );
      }

      clearTimeout(timer.current);
    } else {
      document.addEventListener('cms', evtListener);
    }
  };

  useEffect(() => {
    // 全局获取当前用户信息，接口响应成功，受监听的页面会跟随变化
    loginStore.getUserInfo();
    handleGetCmsData();
    const getData = async () => {
      await getWxConfig();
    };
    getData();
  }, []);

  return (
    <Suspense
      // fallback={
      //   <div className="zp_mobile_all_page_loading">
      //     <Loading />
      //   </div>
      // }
      fallback={WaitJsLoading}
    >
      <BrowserRouter basename="/m/">
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/m" element={<Navigate to="/home" />} />
          {/* 下线“零售启航计划”，自动重定向到校园招聘 */}
          <Route path="/qihang" element={<Navigate to="/campus" replace />} />
          <Route
            path="/personalCenter/resumeDetail"
            element={<RedirectWithSearch to="/personal-center/resume-detail" />}
          />
          <Route
            path="/personalCenter/deliveryRecord"
            element={<RedirectWithSearch to="/personal-center/delivery-record" />}
          />
          <Route
            path="/personalCenter/accountSetting"
            element={<RedirectWithSearch to="/personal-center/account-setting" />}
          />
          {routes.map(({ path, element, isAuth }) => (
            <Route key={path} path={path} element={isAuth ? <Auth>{element}</Auth> : element} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}
